import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { CommissionStore } from './commission.store';

@Injectable()
export class CommissionResolver implements Resolve<any> {

  constructor(
    private commissionStore: CommissionStore,
  ) { }

  resolve() {
    return this.commissionStore.loadPaymentRequestDetails();
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/service/commission.resolver.ts